<template>
  <div id="app">
    <div v-if="!_isMobile">
      <el-container>
        <el-header>
          <div class="flex-row flex-justify-center">
            <div class="header-box">
              <div class="header-logo-box flex-row flex-align-center">
                <div class="logo-img" @click="gotoMain">
                  <img
                    style="border-radius: 10px"
                    src="@/assets/img/logo.png"
                    alt=""
                  />
                </div>
                <div class="f12 text-color-666 ml20" style="width: 266px">
                  除了专业的指导，你可能还需要经验的咨询
                </div>
              </div>
              <!-- 导航条 -->
              <el-menu
                class="el-menu-demo"
                mode="horizontal"
                background-color="#fff"
                text-color="#222222"
                active-text-color="#3d7eff"
                :default-active="activeIndex"
                @select="handleSelect"
              >
                <el-menu-item index="/">首页</el-menu-item>
                <!-- && authJson.gk == 'N' -->
                <el-menu-item index="/register/experiencer">
                  成为“经验家”</el-menu-item
                >
                <el-menu-item index="/plaza"> 广场精选</el-menu-item>
                <el-submenu index="3">
                  <template slot="title">小程序</template>
                  <min-program> </min-program>
                </el-submenu>
                <el-menu-item index="4" v-if="!token">登录|注册</el-menu-item>
                <el-submenu index="/mine" v-else>
                  <template slot="title">{{ userName }} </template>
                  <el-menu-item index="/mine/mine">个人中心</el-menu-item>
                  <el-menu-item index="/mine/order">我的订单</el-menu-item>
                  <el-menu-item index="/mine/services/order" v-if="hasAuth"
                    >服务订单</el-menu-item
                  >
                  <el-menu-item index="/mine/services" v-if="hasAuth"
                    >服务管理</el-menu-item
                  >
                  <el-menu-item index="/mine/wallet">我的钱包</el-menu-item>
                  <el-menu-item @click="logoutAction">退出登录</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>

          <el-divider></el-divider>
        </el-header>

        <el-main>
          <router-view v-if="isRouterAlive" />
          <el-footer>
            <div class="footer-box">
              <span class="text-center">无线可能信息科技（河南）有限公司</span>
              <span class="text-center">
                <a href="https://beian.miit.gov.cn/">豫B2-20212245 | 豫ICP备2021019356号</a>
              </span>
              <span class="text-center">
                郑州市高新技术产业开发区西三环路289号大学科技园东区9号楼12层62号  邮箱：kdx@youngbeyond.com
              </span>
            </div>
          </el-footer>
        </el-main>

        <div class="floating-window">
          <img class="img-1" src="@/assets/img/invite_img.png" alt="" />
          <img class="img-2" src="@/assets/img/qr_code_2.jpg" alt="" />
          <!-- <div class="text-color-666 f12 text-center">微信小程序</div> -->
        </div>
        <login-alert
          v-if="showLogin"
          @wxLogin="wxLogin"
          @close="close"
          @login="login"
        ></login-alert>
      </el-container>
    </div>
    <div v-else>
      <keep-alive>
        <router-view v-if="isRouterAlive" />
      </keep-alive>

      <!--
    <div class="content">

        <MiHome v-if="minDefaultIndex == 0" @click="gotoDestail"></MiHome>
        <MiPlaza v-if="minDefaultIndex == 1"></MiPlaza>
    </div>
    <Tabbars @tabbarIndex="tabbarIndex"></Tabbars> -->
    </div>
  </div>
  <!-- <div class="box">
        <div class="title">
          <img src="@/assets/img/logo.png" alt="" />
        </div>
        <div class="adv-box dis-row">
          <div class="text-bold adv-span">考研、留学、志愿填报</div>
          <div class="text-main-color text-bold adv-span">一对一咨询</div>
          <div class="text-bold adv-span">邂逅直系学长学姐，结交你的领路人</div>
        </div>
        <div>
          <div class="swipe-box">
            <carousel-3d
              :autoplay="true"
              :autoplayTimeout="3000"
              :perspective="35"
              :display="5"
              :animationSpeed="1000"
              :width="260"
              :height="370"
            >
              <slide v-for="(item, i) in slides" :index="i" :key="i">
                <div class="img-box">
                  <img :src="item.src" />
                </div>
              </slide>
            </carousel-3d>
          </div>

          <div class="qr-code-box">
            <div
              class="text-center"
              style="font-size: 12px; color: #333; margin-bottom: 10px"
            >
              微信小程序已上线，扫码进入
            </div>
            <div class="qr-code-img">
              <img src="@/assets/img/qr_code.jpg" />
            </div>
          </div>
          <el-footer>
            <div class="footer-box-mi">
              <div class="text-center footer-item">
                无线可能科技（北京）有限责任公司
              </div>
              <div class="text-center footer-item">
                <a href="https://beian.miit.gov.cn/">京ICP备2021013131号-6</a>
              </div>
              <div class="text-center footer-item">
                北京市海淀区中关村北大街127-1号一层102-7室

              </div>
              <div  class="text-center footer-item"> 邮箱：kdx@youngbeyond.com</div>
            </div>
          </el-footer>
        </div>
      </div>  -->
</template>

<script>
import LoginAlert from "@/components/loginAlert";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MinProgram from "@/components/MinProgram";
import router from "./router";
import util from "./util/util";
import Tabbars from "@/components/Tabbar.vue";
import MiHome from "@/components/MiHome.vue";
import MiPlaza from "@/components/MiPlaza.vue";
import cryptoDES from "@/util/cryptoDES";

import {
  removeAll,
  setToken,
  setUserInfo,
  getName,
  setName,
  getToken,
} from "./util/cookie";
import bus from "./util/eventBus";

export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
      showLogin: false,
    };
  },
  data() {
    return {
      minDefaultIndex: 0,
      showLogin: false,
      activeIndex: "/",
      isRouterAlive: true, //控制视图是否显示的变量
      userInfo: {},
      userName: "",
      token: "",
      authJson: {},
      slides: [
        {
          title: "parent",
          slide: 23424234234234,
          src: require("@/assets/miImgs/1.jpg"),
        },
        {
          title: "parent",
          slide: 23424234234234,
          src: require("@/assets/miImgs/2.jpg"),
        },
        {
          title: "parent",
          slide: 23424234234234,
          src: require("@/assets/miImgs/3.jpg"),
        },
        {
          title: "parent",
          slide: 23424234234234,
          src: require("@/assets/miImgs/4.jpg"),
        },
      ],
    };
  },
  computed: {
    hasAuth() {
      return (
        this.authJson.gk == "Y" ||
        this.authJson.lx == "Y" ||
        this.authJson.po == "Y"
      );
    },

    _isMobile() {
      // return false
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  created() {

    if (!this._isMobile) {
      this.token = this.$store.getters.getToken;
      if (this.token) {
        this.getUserInfo();
      }
      bus.$on("newName", (data) => {
        this.userName = data;
      });
      bus.$on("loginSuccess", (data) => {
        this.$nextTick(() => {
          this.showLogin = false;
        });
        this.token = getToken();
        this.getUserInfo();
      });
    }
    // if (this._isMobile) {
    //   this.$router.replace("/mi");
    // } else {
      // this.$router.replace("/");
    // }
  },
  mounted() {},

  methods: {

    gotoDetail(e) {},
    tabbarIndex(index) {
      console.log("index", index);
      this.minDefaultIndex = index;
    },
    imgClick(data, obj) {
      console.log(data, obj);
    },
    gotoMain() {
      this.activeIndex = "/";
      this.$router.push({
        path: "/",
      });
    },
    getUserInfo() {
      let that = this;
      util.axiosFun(that, "/xzxj/api/user/myDetail").then((res) => {
        this.userName = res.name;
        this.authJson = JSON.parse(res.auth);
        setUserInfo(res);
        setName(res.name);
      });
    },
    logoutAction() {
      this.$confirm("您正在进行退出操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.userInfo = {};
          this.userName = "";
          this.token = "";
          this.activeIndex = "/";
          this.$router.push({
            path: "/",
          });
          removeAll();
          this.$message({
            type: "success",
            message: "已退出",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    registerExperience() {},
    handleSelect(key, keyPath) {
      if (key == 3) {
        return;
      }

      if (key == 4) {
        this.showLogin = true;
        return;
      }

      if (key == "/register/experiencer") {
        if (!this.token) {
          //  this.$message({
          //   type: "error",
          //   message: "请先登录",
          // });
          this.activeIndex = "4";
          this.showLogin = true;
          return;
        }
      }

      this.$router.push({
        path: key,
      });
    },

    registerAction() {
      this.showLogin = true;
    },
    showMiniPro() {
      this.$router.push({
        name: "experiencer/service",
      });
    },
    wxLogin() {},
    close() {
      this.showLogin = false;
    },
    login(e) {
      let that = this;
      let para = e;
      util.axiosFun(that, "/xzxj/web/user/loginByPhone", para).then((res) => {
        setToken(res.token);
        this.token = res.token;
        that.getUserInfo();
        that.showLogin = false;
      });
    },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
  components: {
    LoginAlert,
    MinProgram,
    Carousel3d,
    Slide,
    Tabbars,
    MiHome,
    MiPlaza,
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/scss/element-variables.scss";
@import "./assets/scss/default.scss";
@import "./assets/scss/cover.scss";
.carousel-3d-container {
  margin: 0;
}

// .footer-item {
//   margin-bottom: 20px;
// }
.qr-code-box {
  margin-bottom: 20px;
}

.qr-code-img {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 120px;
    width: 120px;
  }
}

.carousel-3d-slide {
  background-color: transparent;
  border-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  .img-box {
    img {
      height: 90% !important;
      width: 90% !important;
      border-radius: 10px;
      box-shadow: 0 0 10px #000;
    }
  }
}

.adv-box {
  margin-top: 20px;
}

.adv-span {
  margin-top: 10px;
  font-size: 1.2em;
  display: block;
}

.box {
  padding: 30px 0 0 0;
  .title {
    // text-align: center;
    // font-size: 24px;
    // font-weight: 600;
    display: flex;
    justify-content: center;
    align-content: center;
    img {
      width: 6em;
      border-radius: 3px;
      box-shadow: 0 0 10px #3d7eff;
    }
  }
  .el-footer {
    background: #333 !important;
    .footer-box-mi {
      line-height: 20px;
      font-size: 12px;
      color: #fff;
    }
  }
}

.el-carousel__item h3 {
  // color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }
// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.el-image-viewer__img {
  max-width: 50% !important;
  max-height: 50% !important;
  width: auto !important;
  height: auto !important;
}

.el-image-viewer__close {
  top: 70px !important;
}

.el-breadcrumb__itemb {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-box /deep/ .el-menu-item {
  padding: 0 1em;
}

input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #fff !important;
}

.el-image-viewer__mask {
  opacity: 0.1;
}

.el-image-viewer__close {
  top: 90px !important;
}

.slide_box .el-input--suffix .el-input__inner {
  width: 180px;
  border-radius: 16px;
  text-align: center;
  font-size: 12px;
}

.container-content-header.search_box .el-input--suffix .el-input__inner {
  text-align: left !important;
}

.el-textarea__inner {
  padding: 5px 10px;
  font-family: "微软雅黑";
  font-size: 12px;
}

html,
body,
.el-container {
  height: 100%;
}

.el-main {
  background: #f5f5f5;
}

.el-header {
  background: #fff;
  padding: 0px !important;
}

.el-header .el-divider--horizontal {
  margin: 0px !important;
}

.el-footer {
  background: #222222;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px !important;
  text-align: center;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  height: auto !important;
  .footer-box {
    line-height: 50px;
  }
}

.el-main {
  display: flex;
  flex-direction: column;
}

.header-box {
  display: flex;
  justify-content: space-between;
}

.header-logo-box {
  width: 24rem;
  height: 60px;
}

.header-logo-box .logo-img {
  width: 5em;
  height: 2.4em;
}

.logo-img img {
  width: 5em;
  height: 2.4em;
}

.floating-window {
  width: 100px;
  height: 220px;
  z-index: 9999;
  background: #fff;
  position: fixed;
  right: 0;
  bottom: 300px;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 16px;
}

.img-1 {
  width: 100px;
  height: 94px;
}

.img-2 {
  // margin: 10px;
  width: 100%;
  height: 90%;
}

.ml20 {
  margin-left: 20px;
}

.flex-row {
  display: flex;
}

.flex-align-center {
  display: flex;
  align-items: center;
}

.flex-justify-center {
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
}

@media screen and (max-width: 1200px) {
  .header-box {
    width: 90vw !important;
  }
}

@media screen and (min-width: 1201px) {
  .header-box {
    width: 80vw !important;
  }
}

.content {
  height: calc(100vh - 64px - 46px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue